const baseUrl = process.env.REACT_APP_BASE_URL;
export const downloadOnos = baseUrl + '/v1/download/template/onos';
export const downloadVnos = baseUrl + '/v1/download/template/vnos';
export const getAllStatus = baseUrl + '/v1/status/all';
export const uploadOnos = baseUrl + '/v1/upload/data/onos';
export const uploadVnos = baseUrl + '/v1/upload/data/vnos';
export const exportAll = baseUrl + '/v1/download/data/chargers?';
export const allVendors = baseUrl + '/v1/manufacturer/all';
export const vendorsWithModels = baseUrl + '/v1/manufacturer';
export const downloadDataTnos = baseUrl + '/v1/download/data/tnos';
export const orderEndpoint = baseUrl + '/v2/generate/vnos';
export const updateStatusEndpoint = baseUrl + '/v1/update/status';
export const getCharger = baseUrl + '/v1/charger?chargerId=';
export const downloadTenant = baseUrl + '/v1/download/data/tnos/';
export const downloadChargerFile = baseUrl + '/v2/download?';
export const deleteEndpoint = baseUrl + '/v1/charger';
export const downloadVendor = baseUrl + '/v1/download/data/vnos?';
